import styled from 'styled-components';

const MyDiv = styled.div`
.card_box {
box-shadow: 0px 0px 20px 0px #00000017;
border-radius: 16px;
.card_label {
font-family: Poppins;
font-weight: 500;
font-size: 12px;
color:#23272E;  
}
.card_icon {
margin-left: 8px;
border: 1.45px solid #145DFD;   
}
.card_value {
font-family: Poppins;
font-weight: 600;
font-size: 24px;
color:#23272E;    
}
.txt {
font-family: Poppins;
font-weight: 500;
font-size: 8px;
color:#FFFFFF
}
`

export default MyDiv